export const getServerErrorMsg = (response: any) => {
  let errorMsg;
  if (response.message) {
    if (Array.isArray(response.message) && response.message.length > 0) {
      errorMsg = response.message[0];
    } else {
      errorMsg = response.message;
    }
  }

  return errorMsg;
};
